import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-ink px-5 py-24 text-paper sm:px-14 sm:py-32" data-id="element-170" data-mp="1mo25ieq8nbl3">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-171" data-mp="1hnw6gdhn2msz">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-172" data-mp="tyv1j080ltsg">
          <h2 className="font-display text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-173" data-mp="tzd8orw7tsf5">
            Découvrez votre offre <em className="text-pen-soft" data-id="element-174" data-mp="p1v052m41f7o">SCIENCES PRÊTES™</em>
          </h2>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-[0_30px_40px_rgba(0,0,0,0.35)] lg:block" data-id="element-175" data-mp="13ym1hhfch0zx" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-paper p-6 text-ink shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)] sm:p-11 lg:col-span-6" data-id="element-176" data-mp="2fbogi81spihz">
          <p className="text-sm font-semibold text-ink/60" data-id="element-177" data-mp="2actl86mn61gz">Le pack SCIENCES PRÊTES™</p>

          <ul className="mt-5 divide-y divide-ink/10 border-y border-ink/10" data-id="element-178" data-mp="pjp8ru1dymmr">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-179" data-mp="uhqvqq1xn63i">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-pen" data-id="element-180" data-mp="zi54kabcyk2l">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-181" data-mp="13iynsqduvap5" />
                </span>
                <span data-id="element-182" data-mp="6vahr6r2j8ly">
                  <span className="block font-medium leading-snug" data-id="element-183" data-mp="6rwg60q8b3fk">{row.label}</span>
                  {row.detail && <span className="mt-0.5 block text-sm text-ink/65" data-id="element-184" data-mp="bqg3a4gk6l9i">{row.detail}</span>}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-185" data-mp="kle4dytv14bx">
            <p className="text-sm font-medium text-ink/70 sm:pb-2" data-id="element-186" data-mp="3k6jc4djeqfzf">Votre pack complet&nbsp;:</p>
            <p className="font-display text-7xl leading-none tracking-tight text-ink sm:text-8xl" data-id="element-187" data-mp="3o84m9r4k4g5x">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-ink/70 sm:justify-end" data-id="element-188" data-mp="qhfl9lt5us7c">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-189" data-mp="154ij5tleb2v7" />
            Paiement unique. Aucun abonnement.
          </p>

          <CtaButton className="mt-8 w-full" data-id="element-190" data-mp="1078x8nx7t9c4" />

          <p className="mt-5 text-center text-xs text-ink/60" data-id="element-191" data-mp="cgcxn4mip9ub">
            Fichiers PDF · Supports imprimables · Aucun produit physique expédié
          </p>
        </div>
      </div>
    </section>;
}